import { EventLabel, InteractionEvent, trackEvent } from '@/helpers/GTM/GTMHelper';
import { type TrackingData } from '@/types';
import type { MenuItem } from '@smg-real-estate/domus';
import { type Ref } from 'vue';

export function useAppTracking(locale: Ref<string>) {
  const handleTrackFooterClick = (data: TrackingData) => {
    trackEvent(InteractionEvent.FOOTER_CLICK, {
      h_event_category_006: InteractionEvent.FOOTER_CLICK,
      h_event_action_007: data.eventAction,
      h_event_label_008: data.eventLabel,
      non_interaction: false,
    });
  };

  const handleTrackNavItemClick = (data: TrackingData) => {
    trackEvent(InteractionEvent.HEADER_CLICK, {
      h_event_category_006: InteractionEvent.HEADER_CLICK,
      h_event_action_007: data.eventAction,
      h_event_label_008: data.eventLabel,
      non_interaction: false,
      h_content_language_116: data.contentLanguage,
    });
  };

  const hasTrackingLabel = (
    menuItem: MenuItem,
  ): menuItem is MenuItem & { trackingLabel: string } => {
    return 'trackingLabel' in menuItem && typeof menuItem.trackingLabel === 'string';
  };

  const getTrackingLabel = (menuItem: MenuItem): string => {
    if (hasTrackingLabel(menuItem)) {
      return menuItem.trackingLabel;
    }
    return InteractionEvent.OPEN_MY_ACCOUNT;
  };

  const handleNavTracking = (menuItem: MenuItem, _event: Event, isMobile = false) => {
    const eventLabel: string = isMobile ? EventLabel.SIDEBAR : EventLabel.TAB_NAVIGATION;
    handleTrackNavItemClick({
      eventAction: getTrackingLabel(menuItem),
      eventLabel,
      contentLanguage: locale.value,
    });
  };

  const handleMainNavTracking = (menuItem: MenuItem, event: Event) => {
    handleNavTracking(menuItem, event, false);
  };

  const handleMobileMenuNavTracking = (menuItem: MenuItem, event: Event) => {
    handleNavTracking(menuItem, event, true);
  };

  return {
    handleTrackFooterClick,
    handleTrackNavItemClick,
    handleMainNavTracking,
    handleMobileMenuNavTracking,
  };
}
